import { selectUser } from './selectUser';
import { IState } from '../../../store';

export const selectIsAgent = (state: IState) => selectUser(state)?.isAgent || false;
